import { successAction, errorAction, types } from "@authzsvc/api-lib";
import { showNotification } from "../notificationUtils";

const notification = (state = {}, action) => {
  const { payload } = action;

  switch (action.type) {
    case successAction(types.SUBSCRIBE_CURRENT_IDENTITY_TO_GROUPS):
      showNotification({
        type: "success",
        message: "Successfully subscribed to group",
      });
      break;
    case successAction(types.UNSUBSCRIBE_CURRENT_IDENTITY_FROM_GROUPS):
      showNotification({
        type: "success",
        message: "Successfully unsubscribed from group(s)",
      });
      break;
    case successAction(types.DELETE_RESOURCE):
      if (payload.request_id)
        showNotification({ type: "warn", message: payload.message });
      else
        showNotification({
          type: "success",
          message: "Successfully deleted resource",
        });
      break;
    case successAction(types.UPDATE_RESOURCE):
    case successAction(types.PATCH_RESOURCE):
      if (payload) {
        if (payload.data.requestorId && payload.message) {
          showNotification({
            type: "warn",
            message: "Approval required",
            description: payload.message,
          });
        } else {
          showNotification({
            type: "success",
            message: "Successfully updated resource",
          });
        }
      }
      break;
    case successAction(types.TRANSFER_RESOURCE_OWNER): {
      if (payload?.data.status === "Pending")
        showNotification({
          type: "warning",
          message: "Approval required by new administrator",
          description: `The new owner of the resource has been notified. 
            Once they accept the request, the ownership will be transferred. Request created: "${payload.data.displayName}"`,
        });
      else
        showNotification({
          type: "success",
          message: "Successfully transfered owner",
        });
      break;
    }
    case successAction(types.LINK_SERVICE_APPLICATION_TO_SERVICE_COLLECTION):
      showNotification({
        type: "success",
        message: "Successfully linked application",
      });
      break;

    case successAction(
      types.UNLINK_SERVICE_APPLICATION_FROM_SERVICE_COLLECTION,
    ):
      showNotification({
        type: "success",
        message: "Successfully unlinked application",
      });
      break;

    case successAction(types.PUT_SERVICE_APPLICATION_SUBSCRIPTION_SETTINGS):
      showNotification({
        type: "success",
        message: "Successfully saved application Subscription Settings",
      });
      break;
    case successAction(types.POST_SERVICE_APPLICATION_TAGS):
      showNotification({
        type: "success",
        message: "Successfully saved application Subscription Tags",
      });
      break;
    case successAction(types.PUT_SERVICE_COLLECTION_ELIGIBLITY_SETTINGS):
      showNotification({
        type: "success",
        message: "Successfully saved Service Collection Eligibility Settings",
      });
      break;
    case successAction(types.POST_SERVICE_COLLECTION):
      showNotification({
        type: "success",
        message: "Successfully created Service Collection",
      });
      break;
    case successAction(types.POST_CREATE_MANAGED_RESOURCE_TYPE):
    case successAction(types.PUT_UPDATE_MANAGED_RESOURCE_TYPE):
      showNotification({
        type: "success",
        message: "Successfully created/updated Managed Resource Type",
      });
      break;
    case successAction(types.DELETE_MANAGED_RESOURCE_TYPE):
      showNotification({
        type: "success",
        message: "Successfully deleted Managed Resource Type",
      });
      break;

    case errorAction(types.DELETE_RESOURCE):
    case errorAction(types.LINK_SERVICE_APPLICATION_TO_SERVICE_COLLECTION):
    case errorAction(types.UNLINK_SERVICE_APPLICATION_FROM_SERVICE_COLLECTION):
    case errorAction(types.PUT_SERVICE_APPLICATION_SUBSCRIPTION_SETTINGS):
    case errorAction(types.POST_SERVICE_APPLICATION_TAGS):
    case errorAction(types.PUT_SERVICE_COLLECTION_ELIGIBLITY_SETTINGS):
    case errorAction(types.POST_SERVICE_COLLECTION):
    case errorAction(types.POST_CREATE_MANAGED_RESOURCE_TYPE):
    case errorAction(types.PUT_UPDATE_MANAGED_RESOURCE_TYPE):
    case errorAction(types.DELETE_MANAGED_RESOURCE_TYPE):
    case errorAction(types.SUBSCRIBE_CURRENT_IDENTITY_TO_GROUPS):
    case errorAction(types.UNSUBSCRIBE_CURRENT_IDENTITY_TO_GROUPS):
    case errorAction(types.GET_ALL_RESOURCES_OF_RESOURCE_TYPE):
    case errorAction(types.GET_REQUESTS_TO_APPROVE):
      showNotification({
        type: "error",
        message: payload?.data?.message
          ? payload.data.message
          : payload?.title
            ? payload.title
            : "An unexpected error occured",
      });
      break;
    case errorAction(types.CANCEL_REQUEST):
    case errorAction(types.APPROVE_REQUEST):
    case errorAction(types.DENY_REQUEST):
    case errorAction(types.UPDATE_RESOURCE):
    case errorAction(types.PATCH_RESOURCE):
    case errorAction(types.TRANSFER_RESOURCE_OWNER):
      showNotification({
        type: "error",
        message: payload?.title,
        description: payload?.data?.message,
      });
      break;
    default:
      break;
  }

  return state;
};

export default notification;
